const getDigits = (value = "") => {
  return String(value || "").replace(/\D/g, "");
};

const hasOnlyPhonePrefix = value => {
  return getDigits(value) === "7";
};

const normalizePhoneInputValue = value => {
  const digits = getDigits(value);

  if (digits.length > 0 && digits[0] !== "7") {
    return `7${digits.slice(1)}`;
  }

  return value;
};

const normalizePastedPhone = (digits, hasOnlyPhonePrefixValue) => {
  const startsWithCountryCode = digits.startsWith("7") || digits.startsWith("8");

  if (digits.length === 11 && startsWithCountryCode) {
    return digits.slice(1);
  }

  if (digits.length !== 10) {
    return null;
  }

  if (hasOnlyPhonePrefixValue) {
    return digits;
  }

  return digits.startsWith("8") ? `7${digits.slice(1)}` : digits;
};

const formatPhone = digits => {
  const phoneDigits = String(digits || "").slice(0, 10);
  const part1 = phoneDigits.slice(0, 3);
  const part2 = phoneDigits.slice(3, 6);
  const part3 = phoneDigits.slice(6, 10);

  let result = "+7";

  if (part1) {
    result += ` (${part1}`;
  }

  if (phoneDigits.length >= 3) {
    result += ")";
  }

  if (part2) {
    result += ` ${part2}`;
  }

  if (part3) {
    result += ` - ${part3}`;
  }

  return result;
};

module.exports = {
  formatPhone,
  getDigits,
  hasOnlyPhonePrefix,
  normalizePastedPhone,
  normalizePhoneInputValue,
};
